import React from 'react'
import { Box } from 'grommet'

const Separator = () => {
  return <Box height="20px" background="lightPrimary" />
}

export default Separator
